import api from './api';
import { resolveSampleDataSource } from './systems/sample-local/sampleLocalMode';
import { sampleLocalStore } from './systems/sample-local/sampleLocalStore';

export interface ActivityData {
  id: string;
  type: 'registration' | 'usage';
  sample_id: number;
  sample_name: string | null;
  /** 同名サンプル見分け用（保管庫 · #引き出し · ケース） */
  storage_label?: string | null;
  activity_date: string;
  created_by_user_id: number;
  creator_name: string | null;
  action: string | null;
  detail: string | null;
  quantity: number | null;
  /** 使用数量の単位（サンプルの unit。空なら UI 側で既定 vials） */
  unit?: string | null;
}

export interface ChartData {
  month: string;
  month_short: string;
  count: number;
}

export interface DashboardStats {
  samples: number;
  storage_rooms: number;
  users: number;
  totalSamples: number;
  totalUsage: number;
  activeSubscriptions: number;
  activeInvoices: number;
  totalUsageRecords: number;
  totalInitialQuantity: number;
  totalRemainingQuantity: number;
  activity_data: ActivityData[];
  chart_data: ChartData[];
}

export interface DashboardStatsResponse {
  success: boolean;
  data: DashboardStats;
}

export const dashboardService = {
  async getStats(options?: { adminViewAll?: boolean }): Promise<DashboardStats> {
    if (resolveSampleDataSource() === 'local') {
      const local = sampleLocalStore.getDashboardStats();
      const totalUsageRecords = local.activity_data.filter((a) => a.kind === 'usage').length;
      return {
        samples: local.total_samples,
        storage_rooms: local.total_storage_rooms,
        users: 1,
        totalSamples: local.total_samples,
        totalUsage: totalUsageRecords,
        activeSubscriptions: 0,
        activeInvoices: 0,
        totalUsageRecords,
        totalInitialQuantity: 0,
        totalRemainingQuantity: 0,
        activity_data: local.activity_data.map((a) => ({
          id: a.id,
          type: a.kind === 'usage' ? 'usage' : 'registration',
          sample_id: a.sample_id,
          sample_name: a.sample_name,
          activity_date: a.created_at,
          created_by_user_id: 0,
          creator_name: a.creator_name ?? null,
          action: a.kind === 'usage' ? '使用' : '登録',
          detail: a.notes ?? null,
          quantity: a.quantity ?? null,
        })),
        chart_data: local.chart_data.map((c) => ({
          month: c.month,
          month_short: c.month.slice(5) || c.month,
          count: c.count,
        })),
      };
    }
    const response = await api.get<DashboardStatsResponse>('/dashboard/stats', {
      params: {
        adminViewAll: options?.adminViewAll ? 'true' : undefined,
      },
    });
    return response.data.data;
  },
};

